function toggleCollection(id) {
  const content = document.getElementById(`collection-${id}`);
  const arrow = document.getElementById(`arrow-${id}`);

  if (content.classList.contains("tlw-hidden")) {
    document.querySelectorAll('[id^="collection-"]').forEach(el => el.classList.add("tlw-hidden"));
    document.querySelectorAll('[id^="arrow-"]').forEach(el => {
      el.classList.add("tlw-hidden");
      el.style.transform = "rotate(0deg)";
    });

    content.classList.remove("tlw-hidden");
    arrow.classList.remove("tlw-hidden");
    arrow.style.transform = "rotate(90deg)";
  } else {
    content.classList.add("tlw-hidden");
    arrow.classList.add("tlw-hidden");
    arrow.style.transform = "rotate(0deg)";
  }
}

// Abrir los elementos según el valor de "open"
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector("section[open]");

  if (section && section.getAttribute("open") === "true") {
    // Abrir todos los elementos si "open" es true
    document.querySelectorAll('[id^="collection-"]').forEach(el => el.classList.remove("tlw-hidden"));
    document.querySelectorAll('[id^="arrow-"]').forEach(el => {
      el.classList.remove("tlw-hidden");
      el.style.transform = "rotate(90deg)";
    });
  } else {
    // Abrir solo el primer elemento si "open" es false o no está presente
    const firstBlock = document.querySelector('[id^="collection-"]');
    const firstArrow = document.querySelector('[id^="arrow-"]');
    if (firstBlock) {
      firstBlock.classList.remove("tlw-hidden");
    }
    if (firstArrow) {
      firstArrow.classList.remove("tlw-hidden");
      firstArrow.style.transform = "rotate(90deg)";
    }
  }
});